import styled, { css } from 'styled-components';
import Button from '@prisjakt/ui-button';
import { Color, Variant } from '@prisjakt/ui-button/src/types';
import { layout } from '@prisjakt/ui-base';

export const Title = styled.div``;

type ToggleButtonProps = {
  shouldTruncate: boolean;
};

export const ToggleButton = styled(Button)<ToggleButtonProps>(
  ({ shouldTruncate }) => css`
    width: 100%;

    ${shouldTruncate &&
      css`
        overflow: hidden;

        ${Title} {
          text-align: center;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      `}
  `
);

type AppliedFilterCountProps = {
  buttonColor: Color;
  buttonVariant?: Variant;
};

export const AppliedFilterCount = styled.span<AppliedFilterCountProps>(
  props => css`
    align-items: center;
    border-radius: 50%;
    display: inline-flex;
    font-weight: 600;
    height: 20px;
    justify-content: center;
    margin: 0 ${layout.measurements.spacing050};
    width: 20px;

    ${props.buttonColor === 'primary' &&
      props.buttonVariant !== 'outlined' &&
      css`
        background: ${props.theme.pill.inverted.bg};
        color: ${props.theme.pill.inverted.text};
      `}
  `
);
